import React, { CSSProperties, FC, JSX } from 'react';
import { Box, MenuItem, Tooltip, useTheme } from '@mui/material';

type EmptyListIndicatorProps = {
  onClickCallback?: () => void;
  searchTerm?: string;
  addStyles?: CSSProperties;
  addContainerStyles?: CSSProperties;
  noSearchTerm?: JSX.Element;
  isWithTooltip?: boolean;
  tooltipLabel?: string;
  tooltipDelay?: number;
};

const EmptyListIndicator: FC<EmptyListIndicatorProps> = ({
  onClickCallback = undefined,
  searchTerm,
  addStyles,
  addContainerStyles,
  noSearchTerm = null,
  isWithTooltip = false,
  tooltipLabel,
  tooltipDelay,
}) => {
  const theme = useTheme();
  const stylesToAdd = addStyles ?? {};
  const containerStyles = addContainerStyles ?? {};

  const getEmptySearchContainer = (content) => {
    const delay = tooltipDelay ?? 500;
    const title = tooltipLabel ?? '';

    if (isWithTooltip) {
      return (
        <Tooltip title={title} placement="bottom" enterDelay={delay}>
          {content}
        </Tooltip>
      );
    } else {
      return <>{content}</>;
    }
  };
  return getEmptySearchContainer(
    <Box
      sx={(theme) => ({
        height: '100%',
        background: theme.palette.dividerLight,
        boxShadow: theme.shadows[8],
        borderRadius: theme.spacing(0, 0, 0.5, 0.5),
        ...containerStyles,
      })}
    >
      <MenuItem
        onClick={onClickCallback}
        sx={{
          height: '100%',
          cursor: onClickCallback ? 'pointer' : 'default',
          opacity: 0.75,
          display: 'flex',
          justifyContent: 'center',
          ...stylesToAdd,
        }}
      >
        {searchTerm ? (
          <>
            <p
              style={{
                fontStyle: 'italic',
                opacity: 0.75,
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
              }}
            >
              אין התאמה עבור &quot;
            </p>
            <p
              style={{
                maxWidth: '52%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                padding: '0 2px',
                fontStyle: 'italic',
                opacity: 0.75,
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
              }}
            >{`${searchTerm}`}</p>
            <p
              style={{
                fontStyle: 'italic',
                opacity: 0.75,
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
              }}
            >
              &quot;
            </p>
          </>
        ) : (
          noSearchTerm
        )}
      </MenuItem>
    </Box>,
  );
};

export default EmptyListIndicator;
